import React, { Component } from 'react';
import apiRequests from './api-helpers/ApiRequests'
import { Container, Row, Col } from 'react-bootstrap';
import update from 'react-addons-update';
import Datetime from 'react-datetime';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';

 class Transports extends Component {



  constructor(props) {
	  super(props);

	  this.state = {
		  report: new Object(),
		  isLoaded: false,
		  pageSize: 15,
		  currentPageNum: 1,
		  totalPagesCount: 1,
		  modalAddItemFormIsVisible: false,
		  searchParams: [],
		  selectedItem: new Object()
	  }

	  this.loadTransportsList = this.loadTransportsList.bind(this);
	  this.loadTransportsListCallback = this.loadTransportsListCallback.bind(this);
	  this.prevPage = this.prevPage.bind(this);
	  this.nextPage = this.nextPage.bind(this);
	  this.selectPage = this.selectPage.bind(this);
	  this.onClickAddNewItem = this.onClickAddNewItem.bind(this);
	  this.onChangeAddItemFormVisibility = this.onChangeAddItemFormVisibility.bind(this);
	  this.addNewItemCallback = this.addNewItemCallback.bind(this);
	  this.searchItems = this.searchItems.bind(this);
	  this.onSelectItem = this.onSelectItem.bind(this);
	  this.onClickCancelItem = this.onClickCancelItem.bind(this);
	  this.cancelNotificationCallback = this.cancelNotificationCallback.bind(this);

  }

	componentDidMount() {

	  this.loadTransportsList();
	}

	componentDidUpdate() {

	}

	loadTransportsList(page) {

		let setPageNum = page ? page : this.state.currentPageNum;
		let params =
		{
			DataInHttpResponse: true,
			SearchParams: [
				...this.state.searchParams,
				{ Name: "page", Value: setPageNum + "" },
				{ Name: "size", Value: this.state.pageSize + "" },
				{ Name: "company", Value: this.props.userData.CompanyWorkflowId + "" }

			],
			ReportID: this.props.t('raportIds.transports')
			
		};
		apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, this.loadTransportsListCallback);
  }


	loadTransportsListCallback(data) {
		let pagesCount = Math.floor(data.count / this.state.pageSize) + 1

		this.setState({
			report: data,
			isLoaded: true,
			totalPagesCount: pagesCount,
			currentPageNum: data.page
		});

	}

	onClickAddNewItem() {

		this.onChangeAddItemFormVisibility(true);
	 }

	onClickCancelItem() {

		let elemId = this.state.selectedItem.id;

		if (typeof elemId !== 'undefined') {

			let cancelNotificationsParams = {
				Id: this.state.selectedItem.id,
				TransportSignature: this.state.selectedItem.cells[8].value,
				GroupBPS: new Object(),
				EntryStartTime: new Date(),
				EntryStopTime: new Date(),
				Stuff: { Id: "1", Name: "1"}
			}

			apiRequests.getDataByUrlWithParam('webconapi/CancelNotification', cancelNotificationsParams , this.cancelNotificationCallback);

		 }
		 


	 }

	 cancelNotificationCallback(data, response) {

		 if (data.Message == 0) {


		 } else if (data.Message == 1) {

			 this.setState((prevState) => ({ isLoaded: false, selectedItem: new Object() }), () => { this.loadTransportsList(this.state.currentPageNum) })

		 }
		 else if (data.Message == 2) {

		 }
		 else if (data.Message == 3) {

		 }
	 }

	onSelectItem(element) {

		 this.setState({ selectedItem: element });
	 }

	addNewItemCallback() {

		let currentPage = 1;
		this.loadTransportsList(currentPage);

	}

	onChangeAddItemFormVisibility(value) {

		this.setState({ modalAddItemFormIsVisible: value });

	}


	prevPage() {

		if (this.state.currentPageNum > 1) {

			this.setState((prevState) => ({ isLoaded: false }), () => { this.loadTransportsList(this.state.currentPageNum - 1) })

		}

	}

	nextPage() {

		if (this.state.currentPageNum < this.state.totalPagesCount) {

			this.setState((prevState) => ({ isLoaded: false }), () => { this.loadTransportsList(this.state.currentPageNum + 1) })

		}

	}

	selectPage() {

	}


	 searchItems(name, value) {
		 const formattedValue = moment.isMoment(value)
			 ? value.format('YYYY-MM-DD') + 'X'   // je�li moment, to YYYY-MM-DDX
			 : value;                             // w przeciwnym razie zostawiamy string bez zmian
		 let searchParam = { Name: name, Value: formattedValue };
		 this.setState(
			 prevState => {
				 const idx = prevState.searchParams.findIndex(obj => obj.Name === name);
				 if (idx === -1) {
					 return { searchParams: [...prevState.searchParams, searchParam] };
				 } else {
					 return {
						 searchParams: update(prevState.searchParams, {
							 [idx]: { $set: searchParam }
						 })
					 };
				 }
			 },
			 () => {
				 this.loadTransportsList(1);
			 }
		 );
	 }



	 getCurrentDateTime(defaultTime = "0:00") {
		 const [hours, minutes] = defaultTime.split(':');
		 return moment().set({ hour: parseInt(hours), minute: parseInt(minutes) }).format('YYYY-MM-DD');
	 }
   
	render() {


		let content = !this.state.isLoaded
			? (
				<Container className="m-0 p-0">
					<div className="row h-100 m-auto justify-content-center">
						<div className="spinner-border text-primary align-self-center" role="status">
						</div>
					</div>
				</Container>
			)

			: (
				<table className="table custom-table-font">
					<thead>
						<tr key="-2">
						<th key="-3" scope="col">#</th>
							{
							  this.state.report.columns.map((column, index) => (
							  	<th 
							  		key={ index } 
							  		scope="col" 
							  		className={"" + column.name == "ID" ? "d-none" : ""} >
							  			{ column.name.replace('[Transport]','') }
							  		</th>
							  ))
							}
						</tr>
					</thead>
					<tbody>
						<tr key="-1">
							<th key="-5" scope="row">
								<div className="d-flex flex-column">
									<div className="d-flex flex-grow-1">
										<i className="bi bi-search"></i>
									</div>
								</div>
							</th>
							{
								this.state.report.columns.map((column, index) => {

									let searchParamVal = this.state.searchParams.find(x => x.Name == column.name);
									let inputControl = "";

									if (column.type === "DateTime") {
										inputControl = (
											<Datetime
												inputProps={{
													id: column.id ?? 'IdColumn' + column.name,
													name: column.name,
													placeholder: column.name.replace('[Transport]', ''),
													className: 'form-control fs-7',
													autoComplete: 'off',  
												}}
												dateFormat="YYYY-MM-DD"
												timeFormat={false}
												// je�li w stanie mamy "2025-04-02X", obetnij X, �eby moment zobaczy� tylko dat�
												value={
													searchParamVal
														? moment(
															searchParamVal.Value.replace(/X$/, ''),
															'YYYY-MM-DD'
														)
														: null
												}
												// przeka� od razu warto�� do searchItems � to ona potem sprawdzi moment.isMoment
												onChange={value => this.searchItems(column.name, value)}
												closeOnSelect={true}
											/>

										);
									} else {
										inputControl = <input
											type="text"
											className="form-control fs-7"
											id={column.id ? column.id : "IdColumn" + column.name}
											name={column.name}
											placeholder={column.name.replace('[Transport]', '')}
											onChange={(event) => this.searchItems(column.name, event.target.value)}
											value={searchParamVal ? searchParamVal.Value : ""}
										/>
									}

									return <td key={column.guid ? column.guid : "ColumnKey" + column.name} className={"" + column.name == "ID" ? "d-none" : ""}>
										{inputControl}
									</td>
								})	
							}
						</tr>

						{
							this.state.report.rows.map((row, i) => (
								<tr key={row.id + "_" + i} onClick={() => this.onSelectItem(row)} className={this.state.selectedItem.id == row.id ? "selectedListItem" : ""}>
									<th scope="row">{((this.state.currentPageNum - 1) * this.state.pageSize) + i + 1}</th>
									{
										row.cells.map((cell, j) => {

											let cellVal = "";

											if (j == 1 || j == 2) {
												cellVal = cell.value ? cell.value.substring(0, 16).replace('T', ' ') : "";
											}
											else {
												cellVal = Array.isArray(cell.value) && cell.value[0] ? cell.value[0].name : cell.value;
											}

											return <td key={row.id + "_" + i + "_" + j} className={"" + j == 0 ? "d-none" : ""}>{cellVal}</td>

										})
									}
								</tr>
							))
						}
					</tbody>
				</table>
			)

		return (
			<Container className="px-0 pt-0" fluid>
				<div className="tables-nav">
					<nav aria-label="Page navigation" >
						<ul className="pagination">
							<li className="page-item">
								<a className="btn btn-outline-dark" onClick={this.prevPage}>
									<span aria-hidden="true">&laquo;</span>
									<span className="sr-only"></span>
								</a>
							</li>
							<li className="page-item"><a className="btn btn-outline-dark mx-1 font-weight-600">{this.state.currentPageNum}</a></li>
							<li className="page-item">
								<a className="btn btn-outline-dark" onClick={this.nextPage}>
									<span aria-hidden="true">&raquo;</span>
									<span className="sr-only"></span>
								</a>
							</li>
						</ul>
					</nav>
					<div className="m-0 p-0">
						<button type="button" className="btn btn-outline-dark mx-1 font-weight-600" onClick={this.onClickCancelItem} disabled={Object.keys(this.state.selectedItem).length === 0}><i className="bi bi-x-circle me-2"></i>{this.props.t('common.cancel')}</button>
					</div>{/*
					<div className="m-0 p-0">
						<button type="button" className="btn btn-outline-dark mx-1 font-weight-600" disabled><i className="bi bi-pencil-square me-2"></i>Edytuj</button>
					</div>*/}
				</div>
				<div className="m-0 p-0">
						{content}
				</div>
			</Container>
		);
  }
}

function withMyHook(Component) {


	return function WrappedComponent(props) {

		const userData = useSelector((state) => state.currentUser.userData);
		const { t } = useTranslation();

		return <Component {...props} userData={userData} t={ t } />;
	}
}

export default withMyHook(Transports)
